module.exports = __webpack_public_path__ + "media/images/undraw/shift/data_trends-3628ad5fb95cdf52d2c7086a96aee89b.png";